// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progressBarWizard {
    padding: 60px 120px;
}

.progressBarHolder {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    padding: 15px 30px;
}

.progressBarLabels {
    display: grid;
    grid-template-rows: 30px;
    margin-top: 10px;
    margin-bottom: 5px;
    color: var(--integration-text-color);
    font-family: 'MetropolisNF', sans-serif;
    font-size: 18px;
}

.progressBarLabel {
    align-self: center;
    text-align: center;
}

    .progressBarLabel.progressBarLabelsFirst {
        text-align: left;
    }

    .progressBarLabel.progressBarLabelsLast {
        text-align: right;
    }

.bottom-btn-div {
    display: flex;
    margin-top: 10px;
    margin-bottom: 20px;
    font-size: 15px;
}

.pBWLeftButton {
    margin-right: 20px;
}

.contentheader {
    display: flex;
    justify-content: flex-start;
    font: normal normal 600 20px/27px Segoe UI;
    color: var(--integration-text-color);
    opacity: 1;
    margin-top: 60px;
    margin-bottom: 20px;
}

.progressBarWizardContentBorder {
    border: 1px solid var(--integration-border-color);
    border-radius: 12px;
    box-shadow: 0px 3px 6px #00000029;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/progressbarwizard/progressbar.wizard.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;IACpC,uCAAuC;IACvC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;IAEI;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;AAEJ;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,0CAA0C;IAC1C,oCAAoC;IACpC,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iDAAiD;IACjD,mBAAmB;IACnB,iCAAiC;AACrC","sourcesContent":[".progressBarWizard {\n    padding: 60px 120px;\n}\n\n.progressBarHolder {\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    padding: 15px 30px;\n}\n\n.progressBarLabels {\n    display: grid;\n    grid-template-rows: 30px;\n    margin-top: 10px;\n    margin-bottom: 5px;\n    color: var(--integration-text-color);\n    font-family: 'MetropolisNF', sans-serif;\n    font-size: 18px;\n}\n\n.progressBarLabel {\n    align-self: center;\n    text-align: center;\n}\n\n    .progressBarLabel.progressBarLabelsFirst {\n        text-align: left;\n    }\n\n    .progressBarLabel.progressBarLabelsLast {\n        text-align: right;\n    }\n\n.bottom-btn-div {\n    display: flex;\n    margin-top: 10px;\n    margin-bottom: 20px;\n    font-size: 15px;\n}\n\n.pBWLeftButton {\n    margin-right: 20px;\n}\n\n.contentheader {\n    display: flex;\n    justify-content: flex-start;\n    font: normal normal 600 20px/27px Segoe UI;\n    color: var(--integration-text-color);\n    opacity: 1;\n    margin-top: 60px;\n    margin-bottom: 20px;\n}\n\n.progressBarWizardContentBorder {\n    border: 1px solid var(--integration-border-color);\n    border-radius: 12px;\n    box-shadow: 0px 3px 6px #00000029;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
